import EditReportDialog from './EditReportDialog';
export default EditReportDialog;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/EditReportDialog/index.js